export const COLLECTION_ID_COL_DEF = '__collectionId';
export const COLLECTION_FIELD_PREFIX = 'collection_';
